import script from "./SecuritySettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecuritySettings.vue?vue&type=script&setup=true&lang=ts"

import "./SecuritySettings.vue?vue&type=style&index=0&id=85bf9e0a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85bf9e0a"]])

export default __exports__